import styled from 'styled-components';
import { animated } from 'react-spring';
import { COLORS } from '../../../styles/variables';
import { device } from '../../../styles/devices';

export const ModelYearFilterFrame = styled.div`
  padding: 24px;
`;

export const ModelYearFilterWrapper = styled.div<{ numberOfRowsInGrid: number }>`
  display: flex;
  font-family: Audi Type;
  flex-direction: column;
  gap: 24px;
  @media ${device.tablet} {
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* Two columns */
    grid-template-rows: ${({ numberOfRowsInGrid }) =>
      `repeat(${numberOfRowsInGrid}, auto)`}; /* Define multiple rows (adjust number as needed) */
    grid-auto-flow: column; /* Fill columns first */
    gap: 23px;
  }
  // overwrite label option of Select audi ui react library component
  .hasValue {
    label:not(:focus-within) {
      animation-name: none;
    }
  }
`;

export const AllYearsWrapper = styled.div<{ expanded?: boolean; contentHeight?: string }>`
  display: flex;
  flex-direction: column;
  gap: 32px;
  overflow: hidden;
  transition:
    max-height 1s ease,
    opacity 0.5s ease,
    margin-top 1.5s ease;
  /* margin-top: ${({ expanded }) => (expanded ? '44px' : '0')}; */
  /* opacity: ${({ expanded }) => (expanded ? `1` : '0')}; */
  /* max-height: ${({ expanded, contentHeight }) =>
    expanded && contentHeight ? contentHeight : '0'}; */
`;

export const CTAWrapper = styled.div<{ expanded?: boolean }>`
  // margin-bottom: ${({ expanded }) => expanded && '44px'};
  margin-top: 24px;
`;

export const ShowAllButton = styled.button`
  color: ${COLORS.grey60};
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  border: none;
  border-bottom: 1px solid ${COLORS.grey60};
  padding-bottom: 2px;
  cursor: pointer;
  background-color: transparent;
`;
